(() => {
  'use strict';

  const initHub = (hub) => {
    if (!hub || hub.dataset.bnLearningMounted === 'true') return;
    hub.dataset.bnLearningMounted = 'true';

    const navLinks = Array.from(hub.querySelectorAll('.bn-learning-hub__sidebar a[href^="#bn-learning-block-"]'));
    const sections = navLinks
      .map((link) => hub.querySelector(link.getAttribute('href')))
      .filter(Boolean);

    if ('IntersectionObserver' in window && navLinks.length && sections.length) {
      const setCurrent = (id) => {
        navLinks.forEach((link) => {
          if (link.getAttribute('href') === `#${id}`) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      };

      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible?.target?.id) setCurrent(visible.target.id);
      }, { rootMargin: '-18% 0px -62% 0px', threshold: [0.12, 0.3, 0.55] });

      sections.forEach((section) => observer.observe(section));
    }

    hub.querySelectorAll('.bn-learning-hub__checklist span').forEach((item, index) => {
      if (item.dataset.bnChecklistMounted === 'true') return;
      item.dataset.bnChecklistMounted = 'true';

      const key = `bn_learning_check_${window.location.pathname}_${index}_${item.textContent.trim().slice(0, 40)}`;
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-pressed', window.localStorage.getItem(key) === 'true' ? 'true' : 'false');
      item.dataset.bnChecked = item.getAttribute('aria-pressed');

      const toggle = () => {
        const next = item.getAttribute('aria-pressed') !== 'true';
        item.setAttribute('aria-pressed', String(next));
        item.dataset.bnChecked = String(next);
        try { window.localStorage.setItem(key, String(next)); } catch (error) {}
      };

      item.addEventListener('click', toggle);
      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggle();
      });
    });
  };

  const init = () => document.querySelectorAll('[data-bn-learning-hub]').forEach(initHub);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
